import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { INPUT_TEXT_TYPES } from 'ui/inputs';
import { Tooltip } from 'ui/tooltip';
import { Modal, ModalFooter, ModalBody, ModalHeader, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { BUTTON_SIZES, Button } from 'ui/button';
import { updateCustomEventLimitRequest, fetchProjectLimitDataRequest } from '../actions';
import { FormRow, StyledInput } from '../Styled';
import { selectProjectLimitData } from '../selectors';

export const CustomEventLimitForm = () => {
  const [projectId, setProjectId] = useState();
  const [customEventLimit, setCustomEventLimit] = useState(8000);
  const [isCustomEventLimitModalOpen, setCustomEventLimitModalOpen] = useState(false);
  const projectLimitData = useSelector(selectProjectLimitData);
  const dispatch = useDispatch();

  useEffect(() => {
    if (projectId) {
      dispatch(
        fetchProjectLimitDataRequest({
          projectId,
        }),
      );
    }
  }, [projectId]);

  const updateLimit = () => {
    dispatch(
      updateCustomEventLimitRequest({
        projectId,
        customEventLimit,
        callback: () => {
          setProjectId(undefined);
          setCustomEventLimit(undefined);
        },
      }),
    );
    setCustomEventLimitModalOpen(false);
  };

  return (
    <div>
      <FormRow>
        <StyledInput
          hasError={false}
          id="projectId"
          isRequired
          onChange={(newProjectId) => setProjectId(newProjectId)}
          placeholder={'Project Id'}
          type={INPUT_TEXT_TYPES.TEXT}
          value={projectId}
        />
        <StyledInput
          hasError={false}
          id="customEventLimit"
          isRequired
          onChange={(newCustomEventLimit) => setCustomEventLimit(newCustomEventLimit)}
          placeholder={'Custom Event Limit'}
          type={INPUT_TEXT_TYPES.TEXT}
          value={customEventLimit}
        />
        <Tooltip
          isEnabled={!projectId || !customEventLimit || !projectLimitData?.id}
          tooltipContent={`${
            !projectLimitData?.id ? 'Project ID does not exist. ' : ''
          } Please enter a valid Project ID and Custom Event Limit`}
        >
          <Button
            onClick={() => setCustomEventLimitModalOpen(true)}
            isDisabled={!projectId || !customEventLimit || !projectLimitData?.id}
          >
            Update
          </Button>
        </Tooltip>
      </FormRow>
      {isCustomEventLimitModalOpen && (
        <Modal
          onClose={() => setCustomEventLimitModalOpen(false)}
          size={MODAL_SIZES.MEDIUM}
          variant={MODAL_VARIANTS.DEFAULT}
        >
          <ModalHeader>Setting custom event limit</ModalHeader>
          <ModalBody>
            <div>Project: {projectLimitData?.name}</div>
            <div>Project ID: {projectLimitData?.id}</div>
            <div>Org ID: {projectLimitData?.organizationId}</div>
            <div>Old Limit: {projectLimitData?.customEventFieldLimit || 'N/A'}</div>
            <div>New Limit: {customEventLimit}</div>
          </ModalBody>
          <ModalFooter>
            <Button onClick={() => updateLimit()} size={BUTTON_SIZES.LARGE}>
              Set limit
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </div>
  );
};
